export enum UserRole {
  User = 'User',
  SuperAdmin = 'SuperAdmin',
  Admin = 'Admin',
}
